import { render, staticRenderFns } from "./NewToDos.vue?vue&type=template&id=7ab1fdc5&scoped=true"
import script from "./NewToDos.vue?vue&type=script&lang=js"
export * from "./NewToDos.vue?vue&type=script&lang=js"
import style0 from "./NewToDos.vue?vue&type=style&index=0&id=7ab1fdc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab1fdc5",
  null
  
)

export default component.exports